import { Influencer } from './dumb.js';
import enhance from './enhancer';

export default enhance(Influencer);
